import UndoIcon from "@mui/icons-material/Undo";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Grid,
} from "@mui/material";
import { useLoaderData, useNavigate } from "react-router-dom";
import Request from "../../../../components/request/Request";
import BreadcrumbsComponent from "../../../../components/shared/breadcrumbs";

const ContractorInProcessRequestModifyPage = () => {
  const data = useLoaderData("root");
  let navigate = useNavigate();

  const onNavigateToListPage = () => {
    navigate("/SLN/Contractor/InProcessRequest");
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={12}>
        <BreadcrumbsComponent />
      </Grid>

      <Grid item xs={12} md={12}>
        <Card>
          <CardHeader
            title={`بررسی درخواست ${data?.request?.fullName || ""}`}
            subheader={"بررسی مراحل و تایید اسناد"}
            action={
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "fit-content",
                }}
              >
                <Button
                  variant="outlined"
                  color="gray"
                  startIcon={<UndoIcon />}
                  onClick={onNavigateToListPage}
                >
                  بازگشت
                </Button>
              </Box>
            }
          />

          <CardContent sx={{ pb: "0 !important" }}>
            <Request
              onNavigateToListPage={onNavigateToListPage}
              source="Contractor"
            />
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default ContractorInProcessRequestModifyPage;
